export default __webpack_public_path__ + "static/media/mobile01.90e9634e.png";